import React from "react";
import styled, { css } from "styled-components";
import { colors } from "utils";

// Figma "Button/Primary" (48 high, radius 8, Inter 700 18/26): shared by the
// Create Groups menu button, the warm-up CTA and the three-card buttons.
export const primaryButtonStyles = css`
  align-items: center;
  background: ${colors.blue500};
  border: none;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  height: 48px;

  &:hover:not(:disabled),
  &:active:not(:disabled) {
    background: ${colors.blue700};
  }
`;

const LabelText = styled.span`
  color: ${colors.milkGlass500};
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 26px;
  padding: 0 4px;
  white-space: nowrap;
`;

const LabelFrame = styled.span`
  display: inline-flex;
  padding: 0 4px;
`;

// The label as Figma nests it: text in a 4px frame inside another 4px frame.
export const PrimaryButtonLabel = ({ children, className }) => (
  <LabelFrame className={className}>
    <LabelText>{children}</LabelText>
  </LabelFrame>
);

// Single 4px frame: the full-width card buttons centre their label instead.
export const PrimaryButtonCenteredLabel = LabelText;
